<template>
  <el-dialog
          title="地图"
          :visible.sync="dialogVisible"
          customClass="customWidth"
          append-to-body
          @opened="dialogOpen"
  >
    <el-form
            ref="form"
            :model="form"
            size="small"
    >
      <div>
        <div>
          <el-input v-model="form.keyword" style="width:300px"></el-input>
          <el-button type="primary" plain  size="mini"    @click="getAddressKeyword()">搜索</el-button>
          经度:<el-input v-model="form.jdcs" style="width:120px"></el-input>
          纬度:<el-input v-model="form.wdcs" style="width:120px"></el-input>
          <el-button type="primary" plain  size="mini"    @click="saveUser()">确定</el-button>
        </div>
        <div id="mapContainer" style="width:700px;height:500px;"></div>
      </div>
    </el-form>

  </el-dialog>

</template>
<style>
  .customWidth{
    width:90%;
  }
</style>
<script charset="utf-8" src="https://map.qq.com/api/js?v=2.exp&key=SB3BZ-6Y6CO-A5IWT-SSZYX-UR3IK-QUBUP"></script>
<script src="https://3gimg.qq.com/lightmap/components/geolocation/geolocation.min.js"></script>
<script>

    import * as userService from "@/api/sys/user";    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
    export default {
        name: "editspeakerForm",
        props: {
            compaddress2:String,
            latitude2:String,
            longitude2:String,
            value: Boolean
        },
        data() {
            return {
                formEdit: true,
                accuseVisible2:true,
                loading: false,
                dialogVisible: false,
                longitude:'',
                kkkk:0,
                latitude:'',

                getAddress: null,
                getAddCode: null,
                marker:null,
                maptt: null,
                form: {
                    keyword:'',
                    jdcs:'',
                    wdcs:''
                }

            };
        },
        watch: {
            value(val) {
                this.dialogVisible = val;
                console.log("--value---"+val);
            },
            compaddress2 (newValue, oldValue) {
                console.log("++++++++++++"+newValue);
                this.form.keyword = newValue;
            },
            latitude2 (newValue, oldValue) {
                console.log("++++++++++++"+newValue);

                this.form.wdcs = newValue;
                this.latitude = newValue;

            },
            longitude2 (newValue, oldValue) {
                console.log("++++++++++++"+newValue);
                this.form.jdcs = newValue;
                this.longitude= newValue;
                  if(newValue!=null && newValue!=""){
                      this.kkkk=1;
                  }
            },

            dialogVisible(val) {
                this.$emit("input", val);
            }
        },
        methods: {
            dialogOpen() {
                this.$refs.form.resetFields();
                this.getMyLocation();


            },
            getAddressKeyword() {
                //通过getLocation();方法获取位置信息值
                this.getAddress.getLocation(this.form.keyword);
            },
            // 通过坐标获得地址
            getAddressCode() {
                var lat = parseFloat(this.form.wdcs);
                var lng = parseFloat(this.form.jdcs);
                var latLng = new qq.maps.LatLng(lat, lng);
                //调用获取位置方法
                this.getAddCode.getAddress(latLng);
            },
            //第一部分
            //定位获得当前位置信息
            getMyLocation() {
                var that = this;
                var maps = require("qqmap");
                maps.init("SB3BZ-6Y6CO-A5IWT-SSZYX-UR3IK-QUBUP", function() {
                    var center;
                    if(that.form.wdcs!=null && that.form.wdcs!=""){
                        center = new maps.LatLng(parseFloat(that.form.wdcs),parseFloat(that.form.jdcs));
                    }else{
                         center = new maps.LatLng(39.916527,116.397128);
                    }
                    that.maptt = new maps.Map(document.getElementById("mapContainer"), {
                            center: center,
                            zoom: 13
                        });

                    qq.maps.event.addListener(that.maptt, 'click', function(event) {
                        if(that.marker!=null){
                        that.marker.setMap(null);
                        }

                        this.latitude = event.latLng.getLat();
                        this.longitude = event.latLng.getLng();

                        that.form.wdcs=this.latitude;
                        that.form.jdcs=this.longitude;
                        var centergg = new maps.LatLng(this.latitude,this.longitude);
                        that.marker = new qq.maps.Marker({
                            map: that.maptt,
                            position: centergg
                        });

                        that.getAddressCode();
                    });

                    //调用地址显示地图位置并设置地址
                    that.getAddress = new qq.maps.Geocoder({
                        complete: function(result) {
                            that.maptt.setCenter(result.detail.location);
                            console.log(result.detail.location);

                            that.form.jdcs=result.detail.location.lng;
                            that.form.wdcs=result.detail.location.lat;
                            that.marker = new qq.maps.Marker({
                                map: that.maptt,
                                position: result.detail.location
                            });
                        }
                    });
                    console.info("===========kkkk=========="+that.kkkk);
                    if(that.kkkk==1){
                        var centergg = new maps.LatLng(that.latitude,that.longitude);
                        that.marker = new qq.maps.Marker({
                            map: that.maptt,
                            position: centergg
                        });
                    }else{
                        that.kkkk==0;
                    }
                    //通过坐标来显示地图地址
                    that.getAddCode = new qq.maps.Geocoder({
                        complete: function(result) {
                            that.form.keyword = result.detail.address;
                        }
                    });




            })
            },
            saveUser() {
                var keyword=this.form.keyword;
                var jdcs=this.form.jdcs;
                var wdcs=this.form.wdcs;
                if(keyword==null || keyword==""){
                    this.$message('地址不能为空');
                    return ;
                }

                if(jdcs==null || jdcs==""){
                    this.$message('经度不能为空');
                    return ;
                }

                if(wdcs==null || wdcs==""){
                    this.$message('纬度不能为空');
                    return ;
                }
                this.dialogVisible = false;
                this.$emit('fatherMethod',keyword,jdcs,wdcs);

            },
            close() {
                this.$refs["form"].resetFields();
                this.dialogVisible = false;
            }
        }
    };
</script>

